/**
 * The three public `VITE_REALTIME_*` build values (TO-468, ADR-0049), read in one
 * place so tests can substitute them. None is secret: a connection still needs a
 * valid Cognito access token.
 */
export interface RealtimeEnv {
	VITE_REALTIME_ENDPOINT?: string
	VITE_REALTIME_AUTHORIZER?: string
	VITE_REALTIME_TOPIC_PREFIX?: string
}

/** The realtime build values of this bundle. */
export const realtimeEnv = (): RealtimeEnv => ({
	VITE_REALTIME_ENDPOINT: import.meta.env.VITE_REALTIME_ENDPOINT,
	VITE_REALTIME_AUTHORIZER: import.meta.env.VITE_REALTIME_AUTHORIZER,
	VITE_REALTIME_TOPIC_PREFIX: import.meta.env.VITE_REALTIME_TOPIC_PREFIX,
})
